import React from 'react'

function FooterTailwind() {
    return (
        <div className="fixed bottom-0 w-full flex flex-col lg:flex-row justify-between items-center px-4 border-l border-gray-100 h-10 text-sm bg-white">
            <div className="flex justify-center items-center flex-wrap text-gray-700 text-sm px-4">
                &copy; {new Date().getFullYear()} SeatSnaps A Product of{'\u00A0'}<a href='https://www.rispit.com/' target="_blank" rel='noreferrer'>Rispit</a>. All Rights Reserved.
            </div>
        </div>
    )
}

export default FooterTailwind
